import { useState } from "react";
import { Link } from "react-router-dom";
import { LOGO, navigation, regions, WHATSAPP } from "@/data/siteData";

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header id="global-header" className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md" data-testid="site-header">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-28">
          <Link to="/" className="flex-shrink-0" data-testid="header-logo-link">
            <img src={LOGO} alt="Domus Dora Idiomas" className="h-28 py-2 w-auto" data-testid="header-logo-image" />
          </Link>
          <nav className="hidden lg:flex items-center space-x-8" aria-label="Navegação principal" data-testid="desktop-navigation">
            {navigation.map((item) => (
              <Link key={item.path} to={item.path} className="text-[var(--dark-text-color)] hover:text-[var(--primary-color)] font-semibold transition-colors duration-300" data-testid={`desktop-nav-${item.path === "/" ? "inicio" : item.path.slice(1)}`}>
                {item.label}
              </Link>
            ))}
            <a href={WHATSAPP} target="_blank" rel="noreferrer" className="bg-[var(--primary-color)] text-white px-6 py-3 rounded-[var(--button-rounded-radius)] font-bold hover:bg-[var(--primary-button-hover-bg-color)] transition-colors duration-300 transform hover:scale-105" data-testid="desktop-schedule-button">Agendar Aula</a>
          </nav>
          <button type="button" onClick={() => setOpen((value) => !value)} className="lg:hidden text-[var(--primary-color)] p-2" aria-expanded={open} aria-label="Abrir menu" data-testid="mobile-menu-toggle">
            <i className={`fas ${open ? "fa-times" : "fa-bars"} text-3xl`} aria-hidden="true" />
          </button>
        </div>
        <nav className={`${open ? "block" : "hidden"} lg:hidden pb-4`} aria-label="Navegação móvel" data-testid="mobile-navigation">
          <div className="flex flex-col space-y-4">
            {navigation.map((item) => (
              <Link key={item.path} to={item.path} onClick={() => setOpen(false)} className="text-[var(--dark-text-color)] hover:text-[var(--primary-color)] font-semibold transition-colors duration-300 py-2" data-testid={`mobile-nav-${item.path === "/" ? "inicio" : item.path.slice(1)}`}>
                {item.label}
              </Link>
            ))}
            <a href={WHATSAPP} target="_blank" rel="noreferrer" className="bg-[var(--primary-color)] text-white px-6 py-3 rounded-[var(--button-rounded-radius)] font-bold text-center" data-testid="mobile-schedule-button">Agendar Aula</a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export const Footer = () => (
  <footer id="global-footer" className="bg-[var(--dark-background-color)] text-white py-16 relative overflow-hidden" data-testid="site-footer">
    <div className="absolute inset-0 opacity-5"><div className="absolute inset-0 dot-pattern" /></div>
    <div className="container mx-auto px-4 lg:px-8 relative z-10">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
        <div>
          <Link to="/" className="inline-block mb-6" data-testid="footer-logo-link"><img src={LOGO} alt="Domus Dora Idiomas" className="h-24 w-auto" data-testid="footer-logo-image" /></Link>
          <p className="text-sm text-gray-300 mb-6 leading-relaxed" data-testid="footer-brand-description">Aprenda italiano de forma leve, prática e personalizada com a Professora Dora Domus.</p>
          <div className="flex items-center space-x-4">
            <a href={WHATSAPP} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="footer-social" data-testid="footer-whatsapp-link"><i className="fab fa-whatsapp text-xl" aria-hidden="true" /></a>
            <a href="https://instagram.com/domusdora" target="_blank" rel="noreferrer" aria-label="Instagram" className="footer-social" data-testid="footer-instagram-link"><i className="fab fa-instagram text-xl" aria-hidden="true" /></a>
          </div>
        </div>
        <div>
          <h2 className="footer-title" data-testid="footer-navigation-title">Navegação</h2>
          <ul className="space-y-3">{navigation.map((item) => <li key={item.path}><Link to={item.path} className="footer-link" data-testid={`footer-nav-${item.path === "/" ? "inicio" : item.path.slice(1)}`}><i className="fas fa-chevron-right text-xs mr-2" aria-hidden="true" />{item.label}</Link></li>)}</ul>
        </div>
        <div>
          <h2 className="footer-title" data-testid="footer-regions-title">Cursos por região</h2>
          <ul className="space-y-3">{["Língua Italiana", "Língua Inglesa", "Literatura e Cultura", "Reforço Escolar", "Preparatório Vestibular", "Escrita Acadêmica"].map((course, index) => <li key={course}><Link to="/cursos" className="footer-link" data-testid={`footer-course-${index + 1}`}><i className="fas fa-check text-[var(--accent-color)] mr-2 text-xs" aria-hidden="true" />{course}</Link></li>)}</ul>
        </div>
        <div>
          <h2 className="footer-title" data-testid="footer-contact-title">Entre em Contato</h2>
          <ul className="space-y-4 text-gray-300 text-sm">
            <li><a href={WHATSAPP} target="_blank" rel="noreferrer" className="flex items-start space-x-3 hover:text-white" data-testid="footer-contact-whatsapp"><i className="fab fa-whatsapp text-xl" aria-hidden="true" /><span><strong className="block">WhatsApp</strong>(11) 94105-8204</span></a></li>
            <li className="flex items-start space-x-3" data-testid="footer-contact-location"><i className="fas fa-map-marker-alt text-lg" aria-hidden="true" /><span><strong className="block">Localização</strong>Alto de Pinheiros<br />São Paulo - SP</span></li>
            <li className="flex items-start space-x-3" data-testid="footer-contact-hours"><i className="fas fa-clock text-lg" aria-hidden="true" /><span><strong className="block">Horário</strong>Seg-Sex: 08h-18h</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white border-opacity-10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
        <p data-testid="footer-copyright">© 2026 Domus Dora Idiomas. Todos os direitos reservados.</p>
        <p data-testid="footer-signature">Feito com dedicação pela Professora Dora</p>
      </div>
    </div>
  </footer>
);

export const WhatsAppFloat = () => (
  <div className="whatsapp-float" data-testid="whatsapp-floating-container">
    <a href={WHATSAPP} target="_blank" rel="noreferrer" aria-label="Falar no WhatsApp" data-testid="whatsapp-floating-button"><i className="fab fa-whatsapp" aria-hidden="true" /></a>
  </div>
);

export const SiteLayout = ({ children }) => <><Header /><main>{children}</main><Footer /><WhatsAppFloat /></>;